export default __webpack_public_path__ + "static/N0262-2dffae1aabbb5f7f96a50503397a2a7b.png";